import api from '@/services/utils/base';


export default class ColumnSettings {
  getColumnSettings(params?: any) {
    return api.get('column-settings', {params})
      .then((res: Bemob.RawResponse<ColumnsSettingsContextServerFormat[]>) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  putColumnSettings(payload: {id:string, name?:string, settings:ColumnsSettingsContextServerFormat[]}) {
    return api.put('column-settings',payload)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  updateColumnWidth(payload: ColumnsSettingsWidth) {
    return api.patch('/column-settings/width', payload)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  updateColumnOrder(payload: {id:string, name?:string, settings:ColumnsSettingsContextServerFormat[]}) {
    return api.patch('/column-settings', payload)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }
  
  deletePreset(id:string) {
    return api.delete('/column-settings/'+id)
  }
}
